const hasKey = <T, K extends string>(
  obj: T,
  key: K,
): obj is T & Record<K, unknown> => {
  return !!obj && typeof obj === 'object' && key in obj;
};

export default hasKey;
